module.exports = __webpack_public_path__ + "img/MenuButton_CK.6da6b715.jpg";